// extracted by mini-css-extract-plugin
export default {"itinerary-divider-icon":"ItineraryString_itinerary-divider-icon__xl7Rg"};